import { Select, Space, Typography } from "antd";
import React from "react";
import {
  DISPLAY_UNIT_OPTIONS,
  DISPLAY_UNIT_TITLES,
  DisplayUnits,
} from "../displayUnits/definitions";
import { getDisplayUnitLabel } from "../displayUnits/converters";

interface DisplayUnitSelectorProps {
  displayUnits: DisplayUnits;
  onChange: <K extends keyof Omit<DisplayUnits, "efficiency">>(
    metric: K,
    unit: DisplayUnits[K]
  ) => void;
}

const DisplayUnitSelector = ({ displayUnits, onChange }: DisplayUnitSelectorProps) => {
  return (
    <div style={{ marginBottom: 16 }}>
      <Typography.Text strong>Display Units</Typography.Text>
      <Space wrap size={12} style={{ display: "flex", marginTop: 12 }}>
        {(["flow", "head", "power", "npshr", "diameter", "viscosity"] as const).map((metric) => (
          <div key={metric} style={{ minWidth: 110 }}>
            <Typography.Text type="secondary" style={{ display: "block", marginBottom: 6 }}>
              {DISPLAY_UNIT_TITLES[metric]}
            </Typography.Text>
            <Select
              value={displayUnits[metric]}
              style={{ width: "100%" }}
              onChange={(value) => onChange(metric, value as DisplayUnits[typeof metric])}
              options={DISPLAY_UNIT_OPTIONS[metric].map((unit) => ({
                value: unit,
                label: getDisplayUnitLabel(metric, unit),
              }))}
            />
          </div>
        ))}
      </Space>
    </div>
  );
};

export default DisplayUnitSelector;
